define('plugin/deposit-paid-events/DepositPaidEventsPlugin',['require','backbone','lib/plugin/PluginAbstract','Config','plugin/deposit-paid-events/view/DepositPaidEventsPayFullAmountView','plugin/deposit-paid-events/view/DepositPaidEventsPayDepositAmountView'],function (require) {

    var Backbone = require('backbone');
    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var Config = require('Config');

    var DepositPaidEventsPayFullAmountView = require('plugin/deposit-paid-events/view/DepositPaidEventsPayFullAmountView');
    var DepositPaidEventsPayDepositAmountView = require('plugin/deposit-paid-events/view/DepositPaidEventsPayDepositAmountView');

    return PluginAbstract.extend({
        /**
         * Initializes plugin
         */
        initialize: function () {
            this.subscribeInvoiceViewEvents();
        },

        /**
         * Subscribe to show deposit view
         */
        subscribeInvoiceViewEvents: function () {
            Backbone.Wreqr.radio.channel('invoice:layout').vent.on(
                'show', _.bind(this.onInvoiceLayoutShow, this)
            );
        },

        /**
         * Display deposit info
         */
        onInvoiceLayoutShow: function (data) {
            var model = data.model;

            if (data.paymentAllowed && data.model.get('status') === 'new' && data.model.get('is_with_deposit_amount') && Config.getInstance().getOption('deposit_paid_events_is_client_can_pay_full_price')) {
                var layout = data.view;
                var view = null;

                if (model.get('rest_amount')) {
                    view = new DepositPaidEventsPayFullAmountView({model: model});
                } else {
                    view = new DepositPaidEventsPayDepositAmountView({model: model});
                }

                this.listenTo(view, 'pay:deposit:amount', this.payDepositAmount);
                this.listenTo(view, 'pay:full:amount', this.payFullAmount);
                this.listenTo(layout, 'payment_processor:pay', function () {
                    layout.getDepositInfoRegion().reset();
                });

                layout.getDepositInfoRegion().show(view);
            }
        },

        /**
         * Pay deposit amount
         *
         * @param invoiceModel
         */
        payDepositAmount: function (invoiceModel) {
            invoiceModel.payDepositAmount();
        },

        /**
         * Pay full amount
         *
         * @param invoiceModel
         */
        payFullAmount: function (invoiceModel) {
            invoiceModel.payFullAmount();
        }
    });

});
